import React, { useState, useEffect } from 'react';
import Link from 'next/link';
import classNames from 'classnames';

import Location from './Location';
import styles from './LocationRail.module.scss';

import SelectedArrow from '../../public/selected-arrow.svg';
import { checkEnabled, checkValue } from '@components/OptionalFeature';
import { useRouter } from 'next/router';

const LocationRail = ({ locations, callback, selected, flow, productId, isUsed, data }) => {
  const setSelected = (num) => {
    callback(locations[num].lat, locations[num].lng, num);
  };

  const router = useRouter();
  const { locale } = router;

  const dealerInfo =  data?.DisplayOptions?.find((x)=>x.Name==='Dealer Info');

  //show PrimaryTitleText
  const showPrimaryTitleText = checkEnabled(dealerInfo.DisplayOptions,'PrimaryTitleText');

  //PrimaryTitleText
  const primaryTitleText = checkValue(dealerInfo.DisplayOptions,'PrimaryTitleText', locale);


  //show SaveLinkText
  const showSaveLinkText = checkEnabled(dealerInfo.DisplayOptions,'SaveLinkText');

  //SaveLinkText
  const saveLinkText = checkValue(dealerInfo.DisplayOptions,'SaveLinkText', locale);

  // show DetailsLinkText
  const showDetailsLinkText = checkEnabled(dealerInfo.DisplayOptions,'DetailsLinkText');

  //DetailsLinkText
  const detailsLinkText = checkValue(dealerInfo.DisplayOptions,'DetailsLinkText', locale);

  // show SecondaryTitleText
  const showSecondaryTitleText = checkEnabled(dealerInfo.DisplayOptions,'SecondaryTitleText');

  //SecondaryTitleText
  const secondaryTitleText = checkValue(dealerInfo.DisplayOptions,'SecondaryTitleText', locale);

  return (
    <div className={classNames(styles.LocationRail)}>
      <div className={classNames(styles.selectedDealer)}>
        <div>
          <SelectedArrow />
        </div>
        <div>
          <h3 className={styles.blockTitle}>{showPrimaryTitleText ? primaryTitleText : null}</h3>{' '}
          {/* TODO: NEED TRANSLATION FOR THIS */}
        </div>
      </div>
      <div>
        {locations &&
          locations.map((location, index) => (
            <div key={`location--${index}`}>
              {index === 1 && (
                <div className={styles.defaultedDealers}>
                  <div>
                    <h3 className={styles.blockTitle}>
                      {showSecondaryTitleText ? secondaryTitleText : null}
                    </h3>
                    {/* TODO: NEED TRANSLATION FOR THIS */}
                  </div>
                </div>
              )}
              <Location
                location={location}
                index={index}
                callback={setSelected}
                selected={selected}
                flow={flow}
                productId={productId}
                isUsed={isUsed}
                showSaveLinkText={showSaveLinkText}
                saveLinkText={saveLinkText}
                showDetailsLinkText={showDetailsLinkText}
                detailsLinkText={detailsLinkText}
              />
            </div>
          ))}
      </div>
    </div>
  );
};

export default LocationRail;
